import clsx from 'clsx';
import { useState } from 'react';
import EmptyState from './EmptyState';
import NftImage from './NftImage';
import useTraitShuffleStore from '../hooks/useTraitShuffleStore';

const TraitShuffleSelect = ({ kitties = [] }) => {
  const [currentPage, setCurrentPage] = useState(1); // State for current page
  const itemsPerPage = 50; // Number of items per page

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = kitties.slice(indexOfFirstItem, indexOfLastItem); // Items to display

  const totalPages = Math.ceil(kitties.length / itemsPerPage); // Total number of pages

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  if (kitties.length === 0 && !isLoading) {
    return (
      <div className='mt-16 flex justify-center'>
        <EmptyState message='You do not have any Fourth Litter Shitty Kitties to swap traits.' />
      </div>
    );
  }

  return (
    <div className='relative'>
      <div className='grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6'>
        {currentItems.map((nft) => (
          <TraitShuffleSelectItem key={nft.id} nft={nft} />
        ))}
      </div>
      {totalPages > 1 && (
        <div className='flex flex-col items-center justify-between mt-8 space-y-4 md:flex-row md:space-y-0'>
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className='px-4 py-2 bg-gray-900 rounded-full hover:bg-gray-700 disabled:opacity-50 transition duration-250'
          >
            Previous
          </button>
          <div className='flex justify-center space-x-2'>
            {Array.from({ length: totalPages }, (_, index) => {
              const pageNumber = index + 1;
              if (pageNumber === 1 || pageNumber === totalPages || (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)) {
                return (
                  <button
                    key={pageNumber}
                    onClick={() => setCurrentPage(pageNumber)}
                    className={clsx(
                      `w-10 h-10 rounded-full transition duration-250`,
                      currentPage === pageNumber ? 'bg-primary-500 text-white' : 'bg-gray-900 hover:bg-gray-700'
                    )}
                  >
                    {pageNumber}
                  </button>
                );
              } else if (pageNumber === currentPage - 2 || pageNumber === currentPage + 2) {
                return (
                  <span key={pageNumber} className='w-10 h-10 flex items-center justify-center'>
                    ...
                  </span>
                );
              }
              return null;
            })}
          </div>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className='px-4 py-2 bg-gray-900 rounded-full hover:bg-gray-700 disabled:opacity-50 transition duration-250'
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

const TraitShuffleSelectItem = ({ nft }) => {
  const { selectedNft, selectNft } = useTraitShuffleStore();
  const isSelected = selectedNft?.id === nft.id;

  const onSelectNft = () => {
    selectNft(nft);
  };

  return (
    <div>
      <button type='button' onClick={onSelectNft} className='relative'>
        <NftImage
          nft={nft}
          className={clsx(
            'overflow-hidden rounded-lg border-4 transition duration-250 hover:border-white',
            isSelected ? 'border-primary-500 hover:border-primary-500' : 'border-transparent'
          )}
        />
      </button>
    </div>
  );
};

export default TraitShuffleSelect;
